import "./index.scss";
import { UserManagement } from "./UserManagement";
import { DependencyInjectionProvider } from "@whatslly/commons/di";
import { UserManagementDataLayerSymbol } from "./stores/UserManagementDataLayerSymbol";
import type { IUserManagementDataLayer, LoadUsersResponse } from "./types/IUserManagementDataLayer";
import type { UserManagementUser } from "./types/UserManagementUser";
import type { LicenseData } from "./types/LicenseData";
import { InviteRemoteSyncSwitch } from "./components/InviteRemoteSyncSwitch";
import { InvitePlatformSwitch } from "./components/InvitePlatformSwitch";
import { InviteDesktopExtensionsSwitch } from "./components/InviteDesktopExtensionsSwitch";
import { NotifyInviterOnSidecarEventsSwitch } from "./components/NotifyInviterOnSidecarEventsSwitch";
import { UpdateExistingUsersSwitch } from "./components/UpdateExistingUsersSwitch";
import { DefaultUserChannels } from "./components/DefaultUserChannels";
import type { DefaultUserChannelsName } from "./components/DefaultUserChannels";
import { PermissionsEditor } from "./components/PermissionsEditor";
import { UserManagementHeader } from "./components/UserManagementHeader";
import { PageHeaderText } from "./components/PageHeaderText";

export {
  UserManagement,
  DependencyInjectionProvider,
  UserManagementDataLayerSymbol,
  InviteRemoteSyncSwitch,
  InvitePlatformSwitch,
  InviteDesktopExtensionsSwitch,
  NotifyInviterOnSidecarEventsSwitch,
  UpdateExistingUsersSwitch,
  DefaultUserChannels,
  PermissionsEditor,
  UserManagementHeader,
  PageHeaderText,
};

export type {
  IUserManagementDataLayer,
  UserManagementUser,
  LicenseData,
  LoadUsersResponse,
  DefaultUserChannelsName,
};
